module.exports = __webpack_public_path__ + "static/media/nouser.471a1ad3.png";